import { useEffect, useCallback } from "react";
import { useAuth } from "../../Context/AuthProvider";
import { useSecMasterOptionsStore } from "../../Store/secMasterOptionsStore";

// Thin wrapper over the shared SecMaster options store. Both the SecMaster
// screen and the search screen call this; the underlying fetch runs once and the
// result is reused (no repeated option API calls between the two screens).
export const useSecMasterOptions = () => {
  const { token } = useAuth();
  const options = useSecMasterOptionsStore((s) => s.options);
  const error = useSecMasterOptionsStore((s) => s.optionsError);
  const loadOptions = useSecMasterOptionsStore((s) => s.loadOptions);
  const refetchOptions = useSecMasterOptionsStore((s) => s.refetchOptions);

  useEffect(() => {
    if (!token) return undefined;
    let cancelled = false;
    // Defer so a screen's primary data fetch (e.g. the SecMaster list) initiates
    // first; the options then load in parallel right after.
    Promise.resolve().then(() => {
      if (!cancelled) loadOptions(token);
    });
    return () => {
      cancelled = true;
    };
  }, [token, loadOptions]);

  const refetch = useCallback(() => {
    if (token) refetchOptions(token);
  }, [token, refetchOptions]);

  return { options, refetch, error };
};
